import React, { Component } from 'react';
import { Router, Route, IndexRoute } from 'react-router';
import { browserHistory } from 'react-router'
import Cookies from 'cookies-js';
import Constants from './Constants.js';

import Base from './Base.js';
import RedirectIfAuthenticated from './auth/RedirectIfAuthenticated.js';
import Home from './Home.js';
import Public from './public/Public.js';
import Login from './auth/Login.js';
import Logout from './auth/Logout.js';
import AuthenticatedArea from './auth/AuthenticatedArea.js';
import Unauthorized from './auth/Unauthorized.js';
import Dashboard from './Dashboard.js';
import TeacherActivity from './TeacherActivity.js';
import ActiveNewUsers from './ActiveNewUsers.js';
import CumulativeSignupsByMonth from './CumulativeSignupsByMonth.js'
import CumulativeStudentsByMonth from './CumulativeStudentsByMonth.js'
import WebsiteSessions from './WebsiteSessions.js';
import ScheduleDemoFunnel from './ScheduleDemoFunnel.js';
import RollingActiveUsers from './RollingActiveUsers.js';
import CreateDemoAccount from './CreateDemoAccount.js';

import '../../node_modules/bootstrap/dist/css/bootstrap.css';
// import $ from 'jquery';

import log from 'loglevel';
log.setDefaultLevel("debug");

import { Provider } from 'react-redux'
import configureStore from '../configureStore.js'
const store = configureStore()


class PulseRouter extends Component {

  checkAuthentication(nextState, replace, callback) {
    log.debug("Checking if user is authenticated.");

    if( Cookies.get('jwtsession')) {

    } else {
      replace(`${Constants.APP_URL_PREFIX}/login`);
    }

    callback();
  }

  render() {
    var self = this;

    return (
      <Provider store={store}>
        <Router history={browserHistory}>

          <Route path="/" component={Base}>
            <IndexRoute component={Home} />

            <Route component={Public}>
              <Route path="unauthorized" component={Unauthorized} />
              <Route path="logout" component={Logout} />

            </Route>

            <Route component={RedirectIfAuthenticated}>
              <Route path="login" component={Login} />
            </Route>

            <Route component={AuthenticatedArea} onEnter={self.checkAuthentication}>
              <Route path="dashboard" component={Dashboard}>
                <Route path="teacher_activity" component={TeacherActivity} />
                <Route path="active_new_users" component={ActiveNewUsers} />
                <Route path="website_sessions" component={WebsiteSessions} />
                <Route path="cumulative_signups_by_month" component={CumulativeSignupsByMonth} />
                <Route path="cumulative_students_by_month" component={CumulativeStudentsByMonth} />

                <Route path="schedule_demo_funnel" component={ScheduleDemoFunnel} />
                <Route path="rolling_active_users" component={RollingActiveUsers} />
                <Route path="create_demo_account" component={CreateDemoAccount} />

              </Route>

            </Route>
          </Route>

        </Router>
      </Provider>

    );
  }
}

export default PulseRouter;



// WEBPACK FOOTER //
// ./src/components/PulseRouter.js